import { FC, RefObject } from 'react'
import Courusel from '../../UI/Icons/Courusel'
import Link from '../../UI/Icons/Link'
import Video from '../../UI/Icons/Video'
import Gallery from '../../UI/Icons/Gallery'
// import Smile from '../../UI/Icons/Smile'
// import Hashtag from '../../UI/Icons/Hashtag'
// import AtIcon from '../../UI/Icons/At'
import { TCanvaPayload } from '../../PostCreation/CanvaButton/CanvaButton'
import { TMediaCallbacks } from '../../../pages/CreatePost'
import { TExtendedPostAttachment } from '../../../store/managePost/newTypes'
import CanvaSettingsDialog from '../CanvaSettingsDialog/CanvaSettingsDialog'

import './FeateresTooltip.scss'

interface Props {
  refMediaCallbaks: RefObject<TMediaCallbacks>
  restrictions: any
  onUpdateCanvaImage: (payload: TCanvaPayload) => void
  attachmentsLength?: number
  activeAttachment: TExtendedPostAttachment | null
}

const FeaturesTooltip: FC<Props> = ({
  refMediaCallbaks,
  onUpdateCanvaImage,
  activeAttachment,
  attachmentsLength,
  restrictions: {
    tag_people = false,
    link,
    video,
    message,
    cards,
    mediaRestrictions,
    ...restRestrictions
  }
}) => {
  const isDisableAddAttachment =
    !!attachmentsLength &&
    (attachmentsLength >= message?.max_mediafiles) &&
    ((!!activeAttachment && !!activeAttachment.object_data) ||
      !activeAttachment?.extra_fields?.is_child_link)
  const isDisableAddChildLink = attachmentsLength! >= cards?.max_cards

  const isShowTooltip = link || video || cards || message?.image || mediaRestrictions?.image
  return isShowTooltip ? (
    <div className='features-tooltip'>
      <div className='features-tooltip__title'>Add to your post</div>
      <div className='features-tooltip__features'>
        {link && !cards && (
          <div
            className='features-tooltip__features__item'
            onClick={() => refMediaCallbaks?.current?.startEditLink(true)}
          >
            <Link />
          </div>
        )}
        {video && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
            onClick={() => refMediaCallbaks?.current?.addVideo()}
          >
            <Video />
          </div>
        )}
        {cards && (
          <div
            onClick={() => refMediaCallbaks?.current?.addChildLink()}
            className={`features-tooltip__features__item ${isDisableAddChildLink && 'disabled'}`}
          >
            <Courusel />
          </div>
        )}
        {(message?.image || mediaRestrictions?.image) && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
          >
            <CanvaSettingsDialog updateImageData={onUpdateCanvaImage} />
          </div>
        )}
        {(message?.image || mediaRestrictions?.image) && !cards && (
          <div
            className={`features-tooltip__features__item ${isDisableAddAttachment && 'disabled'}`}
            onClick={() => refMediaCallbaks?.current?.addImage()}
          >
            <Gallery />
          </div>
        )}
        {/* // !disable up to adding these features */}
        {/* {message?.emoji && (
          <div className='features-tooltip__features__item'>
            <Smile />
          </div>
        )} */}
        {/* {message?.hashtags && (
          <div className='features-tooltip__features__item'>
            <Hashtag />
          </div>
        )} */}
        {/* {tag_people && (
          <div className='features-tooltip__features__item'>
            <AtIcon />
          </div>
        )} */}
      </div>
    </div>
  ) : null
}

export default FeaturesTooltip
